<template>
  <div class="space-y-3 mt-3">
    <NuxtLink v-for="team in teams" :key="team.id" :to="{ name: 'team', params: { team: team.slug }}" class="border bg-white rounded-md p-3 block">
      <div class="flex items-center gap-3">
        <div class="w-10 md:w-12 aspect-square bg-white rounded-sm">
          <TeamLogo class="block w-full h-full" :name="team.name" :slug="team.slug" :logo="team.logo" size="128" :alt="team.abbr" />
        </div>
        <div class="space-y-1">
          <div class="font-bold md:text-lg">{{ team.name }}</div>
          <!-- <div class="text-sm text-slate-500" v-html="team.season?.year" /> -->
        </div>
        <div class="ml-auto text-sky-600 px-2">
          <AtomIcon name="chevron-circle-right" class="text-xl" />
        </div>
      </div>
    </NuxtLink>
  </div>
</template>

<script setup>
definePageMeta({
  layout: 'league'
})

const league = useLeagueStore()
const teams = computed(() => [...league.teams].sort((a, b) =>
  a.name.localeCompare(b.name, 'sv-SE', { sensitivity: 'base' })
))
</script>
